export const getActiveFilterByColumnId = (state, columnId) => {
  let filters = [];
  const filterStateValuesArr = [...state.listing.activeFilter.values()];
  filterStateValuesArr.forEach(async (f) => {
    filters = filters.concat(f);
  });
  return filters.filter((appliedFilter) => (appliedFilter.id === columnId));
};

export const getActiveFilterByListId = (state, listId) => (state.listing.activeFilter.get(listId) || []);
